module.exports = __webpack_public_path__ + "img/img_icp@2x.22a18965.png";